module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Medieval.113f0498.jpg";